import Loader from 'google-maps';
Loader.KEY = 'AIzaSyB73qHz7oKneQ1lHpjbIOXMFpyC8RvJooE';

const settings = {
	lat: 'data-js-lat',
	lng: 'data-js-lng',
	map: '[data-js-map]'
};

export function init () {
	let $map = $(settings.map);
	if ($map.length) {
		let map = $map[0];
		let lng = parseFloat(map.getAttribute(settings.lng));
		let lat = parseFloat(map.getAttribute(settings.lat));

		let loc = { lat, lng };

		Loader.load(g => {
			let genMap = new g.maps.Map(map, {
				center: loc,
				zoom: 14
			});

			new g.maps.Marker({
				position: loc,
				map: genMap
			});
		});
	}
}

init();
